import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  showIcon?: boolean;
}
export function CTAButton({
  children,
  href = '#',
  onClick,
  className = '',
  showIcon = true
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (href.includes('vitalyforms.com/cart')) {
      trackAddToCart();
    }
    onClick?.();
  };
  return <motion.a href={href} onClick={handleClick} className={`
        relative inline-flex items-center justify-center gap-3 
        bg-gradient-to-r from-amber-500 to-amber-600 
        text-white font-bold uppercase tracking-wide
        px-8 py-5 rounded-full shadow-[0_0_20px_rgba(245,158,11,0.3)]
        hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]
        transition-shadow duration-300 text-center
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 20px rgba(245,158,11,0.3)', '0px 0px 40px rgba(245,158,11,0.5)', '0px 0px 20px rgba(245,158,11,0.3)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-20">
      <span className="relative z-10 text-sm md:text-lg" data-id="element-21">{children}</span>
      {showIcon && <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6 relative z-10" data-id="element-22" />}

      {/* Inner glow effect */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-gold-light to-amber-500 opacity-0 hover:opacity-100 transition-opacity duration-300 mix-blend-overlay" data-id="element-23"></div>
    </motion.a>;
}